import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function useFilters(defaultInit = {}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const set = (label, value) => {
    setSearchParams(cur => {
      if (!value) {
        delete cur.delete(label);
      } else {
        cur.set(label, value);
      }
      return cur;
    });
  };

  const get = name => {
    const value = searchParams.get(name);
    if (value) {
      return value;
    }

    if (name === "page") return 1;
    if (name === "items") return 10;
    return undefined;
  };

  const getAll = () => {
    return Object.fromEntries([...searchParams]);
  };

  useEffect(() => {
    if (!defaultInit) return;

    for (const item in defaultInit) {
      const value = get(item);
      if (!value) {
        set(item, defaultInit[item]);
        continue;
      }

      if (item === "page" && value === 1) {
        set("page", defaultInit["page"]);
      }

      if (item === "items" && value === 10) {
        set("items", defaultInit["items"]);
      }
    }
  }, []);

  return { set, get, getAll };
}
